import { RadioOption } from '../../components/Radios';

export enum FormControl {
	SECTION_HEADING,
	INPUT,
	TEXTAREA,
	DATEPICKER,
	RADIOS,
}

export type TFormSection = {
	items: TFormItem[];
};

export type TFormStep = {
	label?: string;
	title: string;
	desc?: string;
	sections?: TFormSection[];
	link?: string;
	visibleAfterConfirm?: boolean;
	canBeFilledLater?: boolean;
};

export type TFormItem = {
	name?: string;
	label: string;
	labelWidth?: number;
	required?: boolean;
	placeholder?: string;
	controlWidth?: number;
	control?: FormControl;
	validation?: any;
	options?: RadioOption[];
};

export enum FORM_STEP {
	WELCOME,
	EVENT,
	PROMOTER,
	TIMES,
	FEE,
	ACCOMODATION,
	SUMMARY,
}

export const formSteps: TFormStep[] = [
	{ label: 'Úvod', link: '/', title: 'Úvod', visibleAfterConfirm: true },
	{
		label: 'Akce',
		title: 'Informace o akci',
		link: 'event',
		visibleAfterConfirm: false,
	},
	{
		label: 'Promotér',
		title: 'Promotér',
		link: 'promoter',
		visibleAfterConfirm: false,
	},
	{
		label: 'Honorář',
		title: 'Honorář',
		link: 'fee',
		visibleAfterConfirm: false,
	},
	{
		label: 'Zvuk a technika',
		title: 'Zvuk a technika',
		desc: 'Tyto údaje je možné doplnit 14 dnů před vystoupením.',
		link: 'tech',
		visibleAfterConfirm: true,
		canBeFilledLater: true,
	},
	{
		label: 'Časy',
		title: 'Časy vystoupení',
		desc: 'Tyto údaje je možné doplnit 14 dnů před vystoupením.',
		link: 'times',
		visibleAfterConfirm: true,
		canBeFilledLater: true,
	},
	{
		label: 'Ubytování',
		title: 'Ubytování',
		desc: 'Tyto údaje je možné doplnit 14 dnů před vystoupením.',
		link: 'accomodation',
		visibleAfterConfirm: true,
		canBeFilledLater: true,
	},
	{
		label: 'Shrnutí a odeslání',
		title: 'Shrnutí a odeslání',
		// desc: 'Nevyplněné údaje je potřeba doplnit nejpozději 14 dnů před vystoupením.',
		sections: [{ items: [] }],
		link: 'summary',
		visibleAfterConfirm: true,
	},
];
